import React, { useEffect } from 'react'
import * as d3 from "d3";
import View01 from './visualization/view01'
import View02 from './visualization/view02';
import View03 from './visualization/view03';

function Visualization (props){
    const data = props.data,
        biobanks = props.biobanks,
        betas = props.betas,
        types = props.types,
        PIPs = props.PIPs,
        AFs = props.AFs,
        format = props.format;

    const chr = props.chr,
        pos = props.pos,
        refV = props.refV,
        altV = props.altV,
        codV = props.codV,
        AF = props.AF,
        dna = props.dna,
        extra = props.extra,
        getExtra = props.getExtra,
        topLoci = props.topLoci,
        ranges = props.ranges,
        setRanges = props.setRanges;

    const settings = {
        defaultRanges: [-17, -12, -7],
        black: '#000',
        white: '#fff',

        blue0: '#042bb7',
        blue1: '#4d69ce',
        blue2: '#96a7e6',
        blue3: '#dfe5fd',

        gray0: '#030303',
        gray1: '#222222',
        gray2: '#595959',
        gray3: '#919191',
        gray4: '#c8c8c8',

        purple0: '#6100bf',
        purple1: '#8b4cd4',
        purple2: '#b599e8',
        purple3: '#dfe5fd',

        pink0: '#ff2497',
        pink1: '#ff7cc1',

        colors: {
            pvalue: ['#dfe5fd', '#96a7e6', '#4d69ce', '#042bb7'],
            nominal: ['#dfe5fd', '#bd99e9', '#9c4cd5', '#7a00c1']
        }
    }

    const [slot, setSlot] = React.useState([]);
    const [locus, setLocus] = React.useState({}); 
    const [vizWidth, setVizWidth] = React.useState(window.innerWidth-30-40);

    window.addEventListener('resize', function(){
        const newVizWidth = window.innerWidth-30-40
        setVizWidth(newVizWidth)
    })

    function defineMinPval (data, bb) {
        if (data.length === 0) return 1
        else {

            var minPval = d3.min(data, d => {if (+d[bb] !== 0) return +d[bb]})
            if (minPval === undefined) return undefined
            // else return Number(minPval.toExponential(2))
            else return minPval
        }
    }

    d3.select('#root')
        .style('display', undefined)
        .style('justify-content', undefined)
        .style('align-items', undefined)
    
    useEffect(()=>{
    })

    return (
        <div id="visualization">
            <View01
                data={data} 
                topLoci={topLoci}
                biobanks={biobanks} 
                pos={pos}
                dna={dna}
                width={vizWidth}
                settings={settings}
                chr={chr}
                refV={refV}
                altV={altV}
                AFs={AFs}
                betas={betas}
                types={types}
                setLocus={setLocus}
                slot={slot}
                setSlot={setSlot}
                defineMinPval={defineMinPval}
                format={format}
                ranges={ranges}
                setRanges={setRanges}
                extra={extra}
                getExtra={getExtra}
                />
            {Object.keys(slot).length > 0 && (
                <View02
                    wholeDataset={data}
                    biobanks={biobanks}
                    types={types}
                    chr={chr} 
                    pos={pos}
                    refV={refV}
                    altV={altV}
                    codV={codV}
                    AFs={AFs}
                    dna={dna}
                    betas={betas} 
                    PIPs={PIPs}
                    width={vizWidth}
                    locus={locus}
                    settings={settings}
                    setLocus={setLocus}
                    slot={slot}
                    setSlot={setSlot}
                    defineMinPval={defineMinPval}
                    format={format}
                    ranges={ranges}
                    extra={extra}
                    />
            )}
            {Object.keys(locus).length > 0 && (
                <View03
                    chr={chr} 
                    pos={pos}
                    refV={refV}
                    altV={altV}
                    codV={codV}
                    AF={AF}
                    AFs={AFs}
                    betas={betas} 
                    PIPs={PIPs}
                    data={locus}
                    wholeDataset={data}
                    locus={locus}
                    biobanks={biobanks}
                    width={vizWidth}
                    settings={settings}
                    extra={extra}
                    getExtra={getExtra}
                    defineMinPval={defineMinPval}
                    format={format}
                    />
            )}
        </div>
    )
}
export default Visualization;